
import { Toast } from "vant";
import Header from "@/components/header/header.vue";
import listEmpty from "@/components/list_empty.vue";
import WishLsit from "@/components/goods/wish-list.vue";
import { inject, reactive, ref } from "vue";
import { getCart } from "@/hooks/index";
import { useRouter } from "vue-router";
export default {
  components: {
    Header,
    listEmpty,
    WishLsit,
  },
  setup() {
    const $http: any = inject("$http");
    const router = useRouter();

    const product = reactive({
      size: 10,
      page: 1,
      total: 500,
    });
    const finished = ref(false);
    const loading = ref(false);
    const onLoad = async () => {
      get_browse_histor();
    };
    const cart_list = ref([]);
    // 购物车数量
    getCart().then((ret) => {
      cart_list.value = ret;
    });
    interface GoodsInfo {
      goods_id?: number;
      promotion_price?: string;
      marketprice?: string;
      title?: string;
      name?: string;
      goods_image_url?: string;
      image?: string;
      price_market?: string;
      goods_price?: string;
      price?: string;
    }
    interface GoodsObj {
      goods: GoodsInfo;
    }
    interface hisData {
      time: string;
      record: any;
    }
    let historyData: any = reactive({ list: [] });
    let goodObj: Array<GoodsInfo> = reactive([]);
    const get_browse_histor = async () => {
      loading.value = true;
      const res = await $http.get_browse_history({
        size: product.size,
        page: product.page,
      });
      if (res.code === 200 && res.data.length >= 0) {
        product.page += 1;
        res.data.forEach((item: any) => {
          if (
            product.page > 2 &&
            item.time == historyData.list[historyData.list.length - 1].time
          ) {
            historyData.list[
              historyData.list.length - 1
            ].record = historyData.list[
              historyData.list.length - 1
            ].record.concat(dataPushFn(item));
            goodObj = [];
          } else {
            let temp = [];
            temp = dataPushFn(item);
            historyData.list.push({
              time: item.time,
              record: temp,
            });
            goodObj = [];
          }

          // historyData.list[length-1].time ==
        });
        if (res.data.length <= 0) {
          finished.value = true;
        }
        loading.value = false;
      }
    };
    const dataPushFn = (item: any) => {
      item.record.forEach((item1: GoodsObj) => {
        if (item1.goods != null) {
          goodObj.push({
            goods_id: item1.goods.goods_id,
            goods_image_url: item1.goods.image,
            name: item1.goods.title,
            promotion_price: item1.goods.price,
            marketprice: item1.goods.price_market,
          });
        }
      });
      return goodObj;
    };
    //添加 删除按钮

    interface stateObj {
      type: string;
      goods_id: any;
    }
    const beforeClose = async (state: stateObj) => {
      if (state.type == "delete") {
        const res = await $http.delete_browse_history({
          action: "delete",
          id: state.goods_id,
        });
        if (res.code == 200) {
          Toast(res.message);
          product.page = 1;
          // finished.value = false
          historyData.list = [];
          get_browse_histor();
        }
      } else {
        // 跳转 商详页
        router.push("");
      }
      //type判断是删除还是加购,goods_id为当前id
    };

    return {
      beforeClose,
      historyData,
      loading,
      finished,
      onLoad,
      cart_list,
    };
  },
};
